const tableCols = [
    {
        field: 'EXPANSION',
        header: '',
        visible: true,
        currency: false,
        export: {visible: false, checked: false},
        width: 25, align: 'center',
        filter: false, sort: false
    },
    {
        field: 'ITEM_ID',
        header: 'Item ID',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 125, align: 'left',
        filter: true, sort: true
    },
    {
        field: 'CUSTOMER_PART_NO',
        header: 'Customer Part No.',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 125, align: 'left',
        filter: true, sort: true
    },
    {
        field: 'RA1_DISPLAY_NAME',
        header: 'Rack',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 150, align: 'left',
        filter: true, sort: true
    },
    {
        field: 'PL1_DISPLAY_NAME',
        header: 'Plant',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 150, align: 'left',
        filter: true, sort: true
    },
    {
        field: 'REORDER_QTY',
        header: 'Reorder Qty',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 75, align: 'right',
        filter: true, sort: true
    },
    {
        field: 'HITS',
        header: 'Hits',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 50, align: 'right',
        filter: false, sort: true
    },
    {
        field: 'TOTAL_QTY',
        header: 'Quantity',
        visible: true,
        currency: false,
        export: {visible: true, checked: true},
        width: 75, align: 'right',
        filter: false, sort: true
    },
    {
        field: 'TOTAL_VALUE',
        header: 'Total Value',
        visible: true,
        currency: true,
        export: {visible: true, checked: true},
        width: 100, align: 'right',
        filter: false, sort: true
    }
];

export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/part-usage/part-usage.cols.ts